<template>
  <div :class="showLeft ? 'search' : 'search search2'">
    <el-row>
      <el-col :span="3">
        <div class="left" v-if="showLeft">
          <ul >
            <li
              v-for="(item,index) in ulList"
              :key="index"
              :class="activeIndex == index ? 'on' : ''"
              @click="leftClick(index)"
            >{{item}}</li>
          </ul>
        </div>
      </el-col>
      <el-col :span="16" :offset="1">
        <div class="search-box">
          <el-input placeholder="请输入检索词" v-model="search" class="input-with-select" suffix-icon="el-icon-search">
            <el-select v-model="select" slot="prepend" placeholder="请选择">
              <el-option label="资源名称" value="1"></el-option>
              <el-option label="作者" value="2"></el-option>
              <el-option label="关键词" value="5"></el-option>
            </el-select>
          </el-input>
        </div>
        <ul class="select-options fx">
          <li
            v-for="(item,index) in selectList"
            :key="index"
            class="select-item">
            <i class="el-icon-check"></i>
            <span>{{item.title}}</span>
            <i class="el-icon-share"></i>
          </li>
        </ul>
      </el-col>
      <el-col :span="1" :offset="1">
        <div>
          <el-link :underline="false" href="#/search" class="high-search">高级检索 <i class="el-icon-arrow-right"></i></el-link>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  props:{
    showLeft:{
      default: true
    }
  },
  data(){
    return {
      // ulList:['教学资源检索','学术文献检索','知识元检索'],
      ulList:['公共课','专业课'],
      activeIndex: 0,
      search:'',
      select:'资源名称',
      selectList:[
        {
          title: '视频'
        },
        {
          title: '课件'
        },
        {
          title: '素材'
        },
        {
          title: '图书'
        },
        {
          title: 'PPT'
        },
        {
          title: '试题'
        }
      ]
    }
  },
  methods:{
    leftClick(index){
      this.activeIndex = index
    }
  }
}
</script>
<style scoped>
.search{
  width: 1000px;
  height: 140px;
  font-size: 14px;
  margin: 40px auto 20px;
}
.search2{
  margin-top: 20px;
}
.left li{
  width: 113px;
  height: 45px;
  user-select: none;
  position: relative;
  padding: 0 10px;
  box-sizing: border-box;
  line-height: 45px;
  text-align: center;
  color: #fff;
  border-right: 1px solid #fff;
  cursor: pointer;
  overflow: hidden;
  transition: all .5s;
}
.left li.on{
  border-right: none;
}
.left li::before{
  content: '';
  position: absolute;
  left: 0;
  width: 113px;
  height: 45px;
  transition: all .3s;
  background: url('../assets/images/search-tab-bg.png') no-repeat;
  transform: translateX(113px);
}
.left li.on::before{
  transform: translateX(0);
}

.search-box >>> .el-select .el-input {
  width: 130px;
  height: 40px;
  color: #333;
  
}
.search-box >>> input{
  height: 40px;
  
}
.search-box >>> .el-input__inner:nth-child(2){
  width: 550px;
}
.search-box >>> .el-input__suffix{
  right: 10px;
  color: blue;
  cursor: pointer;
}
.search-box >>> .el-select .el-input input{
  height: 40px;
  background: #fff;
  border: none;
  text-align: center;
}
.high-search{
  white-space: nowrap;
  margin-top: 10px;
}
.high-search >>> .el-link--inner{
  color: #fff;
}
.high-search >>> .el-link--inner:hover{
  color: #85b2fa;
}
.select-item{
  padding: 6px;
  margin-right: 17px;
  border:1px solid #fff;
  border-radius: 3px;
  user-select: none;
  cursor: pointer;
}
.select-options{
  margin-top: 12px;
  color: #fff;
}
.select-item span{
  padding: 0 5px;
}
</style>